import type { StatusKind } from '../../shared/types';

export interface Badge {
  bg: string;
  fg: string;
  label: string;
}

// Ported verbatim from support.js st() — maps a status kind to badge colors.
const MAP: Record<string, [string, string, string]> = {
  active: ['var(--success-bg)', 'var(--success)', 'Active'],
  planning: ['var(--info-bg)', 'var(--info)', 'Planning'],
  'at-risk': ['var(--warning-bg)', 'var(--warning)', 'At risk'],
  blocked: ['var(--danger-bg)', 'var(--danger)', 'Blocked'],
  done: ['var(--surface-3)', 'var(--text-2)', 'Complete'],
  onboarding: ['var(--info-bg)', 'var(--info)', 'Onboarding'],
  offboarding: ['var(--warning-bg)', 'var(--warning)', 'Offboarding'],
  paid: ['var(--success-bg)', 'var(--success)', 'Paid'],
  pending: ['var(--warning-bg)', 'var(--warning)', 'Pending'],
  approved: ['var(--info-bg)', 'var(--info)', 'Approved'],
  overdue: ['var(--danger-bg)', 'var(--danger)', 'Overdue'],
  draft: ['var(--surface-3)', 'var(--text-2)', 'Draft'],
  connected: ['var(--success-bg)', 'var(--success)', 'Connected'],
  'action-needed': ['var(--warning-bg)', 'var(--warning)', 'Action needed'],
  fte: ['var(--accent-bg)', 'var(--accent)', 'FTE'],
  contractor: ['var(--surface-3)', 'var(--text-2)', 'Contractor'],
};

export function st(kind: StatusKind | string): Badge {
  const v = MAP[kind] || ['var(--surface-3)', 'var(--text-2)', kind];
  return { bg: v[0], fg: v[1], label: v[2] };
}

// Priority badge (kanban cards).
export function prio(k: string): Badge {
  const m: Record<string, [string, string, string]> = {
    High: ['var(--danger-bg)', 'var(--danger)', 'High'],
    Medium: ['var(--warning-bg)', 'var(--warning)', 'Medium'],
    Low: ['var(--surface-3)', 'var(--text-2)', 'Low'],
  };
  const v = m[k] || m.Medium;
  return { bg: v[0], fg: v[1], label: v[2] };
}

// Access-level badge for the Settings access list.
export function accessRoleBadge(role: string): Badge {
  const m: Record<string, [string, string, string]> = {
    super_admin: ['var(--accent-bg)', 'var(--accent)', 'Super Admin'],
    admin: ['var(--accent-bg)', 'var(--accent)', 'Admin'],
    manager: ['var(--info-bg)', 'var(--info)', 'Manager'],
    staff: ['var(--surface-3)', 'var(--text-2)', 'Staff'],
  };
  const v = m[role] || m.staff;
  return { bg: v[0], fg: v[1], label: v[2] };
}
